import React from "react";
import { useEffect } from "react";
import { useState } from "react";

const CopyLink = ({ transcriptId, custom_note_uuid }) => {
  const [isCopy, setIsCopy] = useState(false);
  const copyLinkNote = (link) => {
    setIsCopy(true);

    navigator.clipboard.writeText(`${window.location.origin}${link}`);
  };
  useEffect(() => {
    setTimeout(() => {
      setIsCopy(false);
    }, 500);
  }, [isCopy]);
  return (
    <div
      onClick={() =>
        copyLinkNote(`/chat/${transcriptId}#noteId${custom_note_uuid}`)
      }
      style={{ position: "relative" }}
    >
      <i className="fa fa-link"></i>
      {isCopy && (
        <span
          style={{
            position: "absolute",
            right: 0,
            fontSize: "10px",
            top: "-13px",
            right: "-12px",
          }}
        >
          Copied
        </span>
      )}
    </div>
  );
};

export default CopyLink;



// WEBPACK FOOTER //
// ./src/components/chat/components/CopyLink.js